import React from 'react';

import { Button } from '@mui/material';

import useToggleState from '~/hooks/useToggleState';

import ScheduleDeletionDialog from './ScheduleDeletionDialog';

interface Props {
  scheduleId: string;
  isCustomSchedule?: boolean;
  disabled?: boolean;
  onDelete: (scheduleId: string) => void;
}

function ScheduleDeletionButton({ scheduleId, isCustomSchedule = false, disabled, onDelete }: Props) {
  const {
    isToggled: isDeletionModalOpen,
    toggleOn: openDeletionModal,
    toggleOff: closeDeletionModal,
  } = useToggleState(false);

  return (
    <>
      <Button type="button" variant="text" size="large" color="error" disabled={disabled} onClick={openDeletionModal}>
        Delete schedule
      </Button>
      <ScheduleDeletionDialog
        scheduleId={scheduleId}
        isCustomSchedule={isCustomSchedule}
        open={isDeletionModalOpen}
        onClose={closeDeletionModal}
        onDelete={onDelete}
      />
    </>
  );
}

export default ScheduleDeletionButton;
